export const CALL_SHORTCUTS = Object.freeze({
  toggleMicrophone: "toggle-microphone",
  toggleCamera: "toggle-camera",
  dismiss: "dismiss",
});

const MODIFIED_KEYS = Object.freeze({
  d: CALL_SHORTCUTS.toggleMicrophone,
  e: CALL_SHORTCUTS.toggleCamera,
});
const TYPING_TAGS = ["INPUT", "TEXTAREA", "SELECT"];
const APPLE_PLATFORM = /Mac|iPhone|iPad|iPod/;

export function matchCallShortcut(event) {
  if (event.key === "Escape") {
    return CALL_SHORTCUTS.dismiss;
  }
  const hasCommand = event.metaKey || event.ctrlKey;
  if (!hasCommand || event.altKey || event.shiftKey) {
    return null;
  }

  return MODIFIED_KEYS[String(event.key).toLowerCase()] || null;
}

export function isTypingTarget(target) {
  if (!target) {
    return false;
  }

  return TYPING_TAGS.includes(target.tagName) || Boolean(target.isContentEditable);
}

export function shortcutLabel(key, platform = "") {
  return `${APPLE_PLATFORM.test(platform) ? "⌘" : "Ctrl"} + ${key}`;
}

export function shortcutKeysLabel(key, platform = "") {
  return `${APPLE_PLATFORM.test(platform) ? "Meta" : "Control"}+${key.toUpperCase()}`;
}
